<template>
  <div
    class="page--user"
    :style="`min-height: ${height}px`"
  >
    <Header
      :kind="routeParams.type"
      :status="currentStatus"
    />

    <Form
      :kind="routeParams.type"
      :submit="submitForm"
      :data="userData"
      :status="currentStatus"
      @tryAgain="getUserById"
      @setCurrentStatus="setCurrentStatus"
    />

    <Footer
      :kind="routeParams.type"
      :status="currentStatus"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isArray } from 'utils/functions'
import Header from 'components/user/Header'
import Form from 'components/user/Form'
import Footer from 'components/user/Footer'

export default {
  name: 'UserPage',
  components: {
    Header,
    Form,
    Footer
  },
  computed: {
    routeParams () {
      return this.$route.params
    },

    height () {
      return document.body.offsetHeight
    },

    userId () {
      return this.routeParams.id ? Number(this.routeParams.id) : null
    }
  },
  data () {
    return {
      namespace: 'Views.UserPage',
      submitForm: false,
      userData: null,
      currentStatus: null
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error',
      showAlert: 'snackbar/show'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    handleSubmit () {
      this.submitForm = !this.submitForm
    },

    renderPayload (data) {
      return {}
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    },

    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    },

    async getUserById () {
      if (this.routeParams.type === 'editar') {
        this.currentStatus = STATUS_IS_LOADING

        try {
          const userId = this.userId
          const { data: res } = await this.$apiService.users.getById(userId, {
            showDetails: true
          })

          if (res && !res.valid) {
            const message = this.isValidArray(res.reasons) ? res.reasons[0] : this.$t('Common.genericErrorMsg')
            this.errorAlert(message)
            this.currentStatus = STATUS_FAILED
          } else if (!res.content) {
            this.errorAlert(this.$t(`${this.namespace}.notFound`))
            this.currentStatus = STATUS_FAILED
          } else {
            this.userData = res.content
            this.currentStatus = STATUS_SUCCESS
          }
        } catch (err) {
          console.log('ERROR:', err)
          this.currentStatus = STATUS_FAILED
        }
      }
    }
  },
  watch: {
    'routeParams.id' () {
      location.reload()
    }
  },
  beforeMount () {
    if (this.routeParams.type !== 'cadastrar' && this.routeParams.type !== 'editar') {
      this.$router.push({ name: 'Users' })
    }
  },
  mounted () {
    this.getUserById()

    if (this.routeParams.type !== 'editar') {
      this.currentStatus = STATUS_SUCCESS
    }

    this.setChatPosition('75px', '10px')
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>
